<template>
  <div class="videopage bookpage bg" :class="{'modebg':mode==0}">
    <v-nav @showDownMenu="showDownMenu"></v-nav>
    <mode class="modeapp" v-if="loadMore"></mode>
    <div class="bookdetailpage">
      <div class="read_menu">
        <transition name="fade">
        <div class="setmake chaptlist" v-if="type==1">
          <div class="listitem textover" @click="changeChapt(item)" v-for="item in bookData">{{item.title}}</div>
        </div>
        </transition>
        <transition name="fade">
        <div class="setmake" v-if="type==2">
          <div class="setfont">
            <div class="fonttxt">字　　体</div>
            <div class="fonttype" :class="{'select':fontmode==1}" @click="setFontType(1)">简体</div>
            <div class="fonttype" :class="{'select':fontmode==2}" @click="setFontType(2)">繁体</div>
          </div>
          <div class="font-size">
            <div class="txt">字体大小</div>
            <div class="make" @click="smallSize">－</div>
            <div class="size">{{fontSize}}px</div>
            <div class="make" @click="bigSize">＋</div>
          </div>
          <div class="font-size">
            <div class="txt">文字行距</div>
            <div class="make" @click="smallLineSize">－</div>
            <div class="size">{{fontRate}}倍</div>
            <div class="make" @click="bigLineSize">＋</div>
          </div>
          <div class="setfont">
            <div class="fonttxt">阅读模式</div>
            <div class="fonttype"  :class="{'select':mode==1}" @click="setMode(1)">白天模式</div>
            <div class="fonttype"  :class="{'select':mode==0}"@click="setMode(0)">夜间模式</div>
          </div>
        </div>
        </transition>
        <div class="menu chapt" @click="showDown(1)">
          目录
        </div>
        <div class="menu set" @click="showDown(2)">设置</div>
      </div>

      <div class="read_content" @click="type=0">
        <div class="classname" v-if="bookinfo.className" :style="{'color':fontColor}">《{{bookinfo.title}}》</div>
        <div class="author" :style="{'color':fontColor}"> {{bookinfo.author}}</div>
        <div class="createdate" :style="{'color':fontColor}">{{bookinfo.create_at}}</div>
        <div class="read_main" ﻿:style="{fontSize: `${fontSize*2/100}rem`,lineHeight:`${lineHeight}rem`,color:fontColor}" v-html="bookinfo.content" ref="read"></div>
      </div>

    </div>
  </div>
</template>

<script>
  import mode from '@/components/bg/mode'
  import { traditionalized, simplized } from '../../../static/utils/utils'
    export default {
        name: "bookdetail",
        components:{mode},
        data() {
            return {
              bookData:[],
              bookinfo:{},
              show_menu:0,
              loadMore:true,
              fontSize:14,
              lineHeight:0.44,
              fontRate:1.6,
              fontColor:'#5f4009',
              type:0,
              fontmode:1,
              mode:1,
            }
        },
        mounted() {
          this.getBookCon()
        },
        methods: {
          showDownMenu(data){
            if(data==0){
              this.show_menu=0
            }else{
              this.show_menu=1
            }
          },
           changeChapt(item){
            this.bookinfo=item
            this.type=0
             this.$refs.read.scrollTop=0;
          },
          showDown(type){
           if(this.type==type){
             this.type=0
           }else{
             this.type=type
           }
          },
          getBookCon(){
            let _this=this
            this.$http({
              url: '/Book/sonlist',
              method: 'POST',
              headers: {
                'Content-Type': 'application/json'
              },
              data: {id:this.$route.params.id}
            }).then((res) => {
              console.log(res)
              this.loadMore=false
              if(res.data.code==0){
                this.bookData=res.data.data
                this.bookinfo=res.data.data[0]
                console.log(this.bookinfo)
                console.log(this.bookinfo.content.length)
                // this.totPageFont()
                // if(window.localStorage['setpage']){
                //   let bookinfo=JSON.parse(window.localStorage['setpage'])
                //   if(this.bookinfo.id==bookinfo.id){
                //     this.$layer.confirm('是否从您上次阅读位置开始阅读',function(){
                //       _this.fontSize=bookinfo.fontsize
                //       _this.lineHeight=bookinfo.lineheight
                //       _this.mode=bookinfo.mode
                //       _this.fontColor=bookinfo.fontcolor
                //       _this.fontRate=bookinfo.fontrate
                //       _this.setFontType(bookinfo.fonttype)
                //       _this.$refs["vs"].scrollTo(
                //         {
                //           y:bookinfo.scrolltop
                //         },
                //         500,
                //         "easeInQuad"
                //       );
                //       _this.$layer.closeAll()
                //     },function(){
                //       _this.$layer.closeAll()
                //     })
                //   }
                // }
              }else{
                this.$layer.msg(res.data.msg)
              }
            })
              .catch((error) => {
                // error
                this.$layer.msg('网络错误，请稍后重试')
                this.loadMore=false
                console.log(error)
              })
          },
          setFontType(type){
            console.log(type)
            this.fontmode=type
            this.type=0
            if(type==1){
              this.bookinfo.content = simplized(this.bookinfo.content)
              this.bookinfo.className = simplized(this.bookinfo.className)
              this.bookinfo.author = simplized(this.bookinfo.author)
            }else{
              this.bookinfo.content = traditionalized(this.bookinfo.content)
              this.bookinfo.className = traditionalized(this.bookinfo.className)
              this.bookinfo.author = traditionalized(this.bookinfo.author)
            }
          },
          smallSize(){
            if(this.fontSize>2){
              this.fontSize -= 2
              this.lineHeight=(this.fontSize*2/100)*this.fontRate
            }
          },
          bigSize(){
            this.fontSize += 2
            this.lineHeight=(this.fontSize*2/100)*this.fontRate
          },
          smallLineSize(){
            console.log(this.fontRate)
            if( this.fontRate>0){
              this.fontRate=(this.fontRate-0.1).toFixed(1)
              // (this.fontRate-=0.1).toFixed(1)

              this.lineHeight=(this.fontSize*2/100)*this.fontRate
            }

          },
          bigLineSize(){
            console.log(this.fontRate)
           this.fontRate=Number(this.fontRate)+Number(0.1)
            console.log(this.fontRate)
            this.fontRate=Number(this.fontRate).toFixed(1)
            this.lineHeight=(this.fontSize*2/100)*this.fontRate
          },
          setMode(mode){
            console.log(mode)
            this.mode=mode
            if(mode==0){
              this.fontColor='#bcb6ac'
            }else{
              this.fontColor='#333'
            }
            this.type=0
          },
          totPageFont(){
            this.$nextTick(()=>{
              let domHeight=Math.floor(this.$refs.read.clientHeight);
              let domWidth=Math.floor(this.$refs.read.clientWidth)
              let lineFont=domHeight/this.fontSize
              let lineNum=domWidth/this.lineHeight
              let pageFontNum=lineFont*lineNum//每页字数
              let PageNum= Math.ceil(this.bookinfo.content.length/pageFontNum)//总页数
              console.log(PageNum)
              console.log(domHeight)
            })

          }
        }
    }
</script>

<style scoped lang="scss">
  .fade-enter-active, .fade-leave-active {
    transition: opacity .5s;
  }
  .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
    opacity: 0;
  }
  .bg{
    background: url("../../assets/images/phone/bg.jpg")no-repeat left bottom;
    position: fixed;
    top:0;
    min-height: 100%;
    left:0;
    right:0;
    bottom:0;
    overflow: hidden;
    background-size:100% 100%;
  }
  .modebg{
    background: url("../../assets/images/phone/bg2.jpg")no-repeat left bottom;
    background-size: 100% 100%;
  }
  .bookdetailpage{
    padding:0.3rem 0 0;
    position: absolute;
    box-sizing: border-box;
    top:1rem;
    bottom:0;
    width:100%;
    .read_menu{
      display: flex;
      width:100%;
      padding:0 0.28rem;
      box-sizing: border-box;
      border-bottom:1px solid #c9a168;
      position: relative;
      .setmake{
        position: absolute;
        top:0.76rem;
        left:0.28rem;
        width:calc(100% - 0.56rem);
        right:0.28rem;
        background: rgba(201,161,104,0.9);
        height:4.1rem;
        border-bottom-left-radius: 2px;
        border-bottom-right-radius: 2px;
        padding:0.35rem;
        box-sizing: border-box;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        z-index:999;
        .setfont{
          display: flex;
          .fonttxt{
            font-size:0.28rem;
            color:#fff;
          }
          align-items: center;
          .fonttype{
            width:1.8rem;
            height:0.52rem;
            background:#fff;
            border-radius:2px;
            font-size:0.28rem;
            color:#c18e46;
            border:0.01rem solid #fff;
            box-sizing: border-box;
            line-height: 0.5rem;
            text-align: center;
            margin-left:0.35rem;
          }
          .select{
            background:#c18e46;
            color:#fff;
          }
        }
        .font-size{
          display: flex;
          align-items: center;
          margin-top:0.35rem;
          .txt{
            font-size:0.28rem;
            color:#fff;
            padding-right:0.35rem;
          }
          .make{
            width:0.75rem;
            height:0.52rem;
            background:#fff;
            text-align: center;
            color:#c18e46;
            font-weight: bold;
            border-radius:2px;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size:0.28rem;
          }
          .size{
            width:2.3rem;
            height:0.52rem;
            border-radius:2px;
            background:#fff;
            text-align: center;
            line-height: 0.52rem;
            font-size:0.28rem;
            margin:0 0.1rem;
          }
        }
      }
      .chaptlist::-webkit-scrollbar{
        display: none;
      }
      .chaptlist{
        justify-content: flex-start;
        padding:0;
        overflow-y: auto;
        max-height:4.1rem;
        height:auto;
        .listitem{
          height:0.78rem;
          border-bottom:1px dashed #d3bfa2;
          padding:0 0.4rem;
          box-sizing: border-box;
          line-height: 0.78rem;
          color:#fff;
          font-size:0.26rem;
          flex-shrink:0;
        }
      }
      .menu{
        width:1.8rem;
        height:0.76rem;
        border-top-left-radius: 3px;
        border-top-right-radius: 3px;
        padding-left:0.87rem;
        box-sizing: border-box;
        line-height: 0.76rem;
        color:#fff;
        font-size:0.28rem;
        position: relative;
      }
      .chapt{
        background: url("../../assets/images/phone/chaptread.png")no-repeat 0.4rem center #c9a168;
        background-size:0.28rem auto;
      }
      .set{
        background: url("../../assets/images/phone/seticon.png")no-repeat 0.4rem center #c9a168;
        background-size:0.28rem auto;
        margin-left:0.2rem;
      }
    }
    .read_content{
      height:calc(100% - 1.5rem);
      .classname{
        text-align: center;
        font-size:0.32rem;
        color:#5f4009;
        padding:0.35rem 0 0.2rem;
      }
      .author{
        text-align: center;
        font-size:0.28rem;
        color:#5f4009;
      }
      .read_main{
        overflow: auto;
        padding:0 0.28rem;
        box-sizing:border-box;
        width:100%;
        height:calc(100% - 2rem);
      }
      .read_main::-webkit-scrollbar{
        display: none;
      }
      .createdate{
        text-align: center;
        font-size:0.28rem;
        color:#5f4009;
        padding:0.2rem 0;
      }
    }

  }

</style>



// WEBPACK FOOTER //
// src/views/m/bookdetail.vue